import React, { Component } from "react";
import MinNav from "../component/MinNav";
import AllAudioTable from "./AllAudioTable";
import AudioMessageEditor from "../../editors/AudioMessageEditor";
import { ReactComponent as CloseSVG } from "./../../images/svg/close.svg";

class AllAudio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      storeState: true,
      postID: "",
      title: "",
      mainPost: "",
      audio: "",
      setter: "insert"

    };

    this.postDelete = this.postDelete.bind(this);
    this.onChange = this.onChange.bind(this);
    this.startUpdate = this.startUpdate.bind(this);
  }

  startUpdate(e) {
    this.setState({
      setter: "update",
      postID: e.target.getAttribute("data-id"),
      title: e.target.getAttribute("data-title"),
      audio: e.target.getAttribute("data-audio"),
      mainPost: e.target.getAttribute("data-post"),
    });
  }

  onChange(e) {
    this.setState({ storeState: false });
    let searchValues = e.target.value;
    fetch(`${this.props.apiROOT}newsletter/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.posts.length > 0) {
          this.setState({ posts: data.posts });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  postDelete(e) {
    if (window.confirm('Delete this audio message')) {
      let postID = e.target.getAttribute("data-id");
      fetch(`${this.props.apiROOT}post/deleteMessage/${postID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            //eslint-disable-next-line
            this.state.posts.map((p, i) => {
              if (p.post_id === postID) {
                delete this.state.posts[i];
              }
            });
            this.setState({ posts: this.state.posts });
          }
        });
    }
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}category/message`)
      .then(res => res.json())
      .then(data => {
        if (data.posts == null) return;
        this.setState({
          posts: data.posts
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {

    if(this.state.setter == "update") {
      this.props.toggleAudioMessageEditor();
    }

    return (
      <div className="a-container">
        <MinNav />
        <div className="" style={{ width: 200 + "px", margin: 10 + 'px auto' }}>
          <a href="#">
            <button className="btn shadow"
              onClick={this.props.toggleAudioMessageEditor}
              style={{ margin: 10 + ' auto', backgroundColor: 'green' }}>Add Audio Message</button>
          </a>
        </div>
        <div style={{ padding: 5 + "px " + 1 + "%", margin: 10 + 'px auto' }}>
          <input
            placeholder="Search post title, post ID..."
            onChange={this.onChange}
            style={{ background: "#f9f9f9", width: 80 + "%", margin: 10 + 'px auto', display: 'block' }}
          />
        </div>

        <AllAudioTable
          posts={this.state.posts}
          apiROOT={this.props.apiROOT}
          root={this.props.root}
          postDelete={this.postDelete}
          startUpdate={this.startUpdate}
          toggleAudioMessageEditor={this.props.toggleAudioMessageEditor}
        />

        <div className="audio-editor-wrapper hide">
          <span
            className="audio-editor-wrapper-close"
            onClick={this.props.toggleAudioMessageEditor}
          >
            <CloseSVG /> Close
              </span>

          <AudioMessageEditor
            apiROOT={this.props.apiROOT}
            root={this.props.root}
            post_title={this.state.title}
            postID={this.state.postID}
            mainPost={this.state.mainPost}
            audio={this.state.audio}
            setter={this.state.setter}
          />
        </div>
      </div>
    );
  }
}

export default AllAudio;
